<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">实训基地列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="基地名称">
          <el-input v-model="formInline.name" @blur="handleQuery" placeholder="请输入基地名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载实训基地导入模版</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleBatchDel">批量删除</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            :btnTitle="btnTitle"></Importt>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%"
        @selection-change="handleSelectionChange(...arguments, 'id')">
        <custom-table-column type="selection" width="40">
        </custom-table-column>
        <custom-table-column fixed prop="name" min-width="160" label="名称">
        </custom-table-column>
        <custom-table-column prop="base_no" width="120" label="编号">
        </custom-table-column>
        <custom-table-column prop="xxdm" width="120" label="学校代码">
        </custom-table-column>
        <custom-table-column prop="structure_1" width="160" label="院系">
        </custom-table-column>
        <custom-table-column prop="base_type" width="160" label="实训基地类别">
        </custom-table-column>
        <!-- <custom-table-column prop="base_type2" width="140" label="实训基地类别码">
        </custom-table-column> -->
        <custom-table-column prop="prop" width="120" label="性质">
        </custom-table-column>
        <custom-table-column prop="person" width="100" label="负责人">
        </custom-table-column>
        <custom-table-column prop="area" width="100" label="面积（m²）">
        </custom-table-column>
        <custom-table-column prop="training_room_count" width="120" label="实训室数量">
        </custom-table-column>
        <custom-table-column prop="support_department" width="190" label="被列为实训基地项目支持部门">
        </custom-table-column>
        <custom-table-column prop="equipment_total" width="120" label="仪器设备总数">
        </custom-table-column>
        <custom-table-column prop="full_time_admin_count" width="160" label="管理人员（专职）数">
        </custom-table-column>
        <custom-table-column prop="part_time_admin_count" width="160" label="管理人员（兼职数）">
        </custom-table-column>
        <custom-table-column prop="workstation" width="120" label="工位数">
        </custom-table-column>
        <custom-table-column prop="training_project_total" width="120" label="实训项目总数">
        </custom-table-column>
        <custom-table-column prop="approval_date" width="180" label="批准日期">
        </custom-table-column>
        <custom-table-column prop="jlrq" width="180" label="建立日期">
        </custom-table-column>
        <custom-table-column prop="ssgldwh" width="120" label="所属管理单位号">
        </custom-table-column>
        <custom-table-column prop="ytdw" width="160" label="依托单位">
        </custom-table-column>
        <custom-table-column prop="major_name" width="160" label="适应专业名称">
        </custom-table-column>
        <custom-table-column prop="hzqy" width="160" label="合作企业">
        </custom-table-column>
        <custom-table-column prop="jlrq" width="180" label="建立日期">
        </custom-table-column>
        <custom-table-column prop="summary" width="220" label="概述">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="学校代码" prop="xxdm">
          <el-input v-model="ruleForm.xxdm" placeholder="请输入学校代码" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="基地编号" prop="base_no">
          <el-input v-model="ruleForm.base_no" placeholder="请输入基地编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="基地名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入基地名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="院系" prop="structure_1">
          <el-input v-model="ruleForm.structure_1" placeholder="请选择院系" style="width:216px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item label="实训基地类别" prop="base_type">
          <el-select v-model="ruleForm.base_type" filterable clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.baseType" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="实训基地类别码" prop="base_type2">
          <el-input v-model="ruleForm.base_type2" placeholder="请输入实训基地类别码" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item label="性质" prop="prop">
          <el-input v-model="ruleForm.prop" placeholder="请输入性质" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="院系" prop="structure_1">
          <el-input v-model="ruleForm.structure_1" placeholder="请输入院系" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item label="负责人" prop="person">
          <el-input v-model="ruleForm.person" placeholder="请输入负责人" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="面积" prop="area">
          <el-input v-model="ruleForm.area" placeholder="请输入面积" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训室数量" prop="training_room_count">
          <el-input v-model="ruleForm.training_room_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训项目总数" prop="training_project_total">
          <el-input v-model="ruleForm.training_project_total" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="工位数" prop="workstation">
          <el-input v-model="ruleForm.workstation" placeholder="请输入工位数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="仪器设备总数" prop="equipment_total">
          <el-input v-model="ruleForm.equipment_total" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="管理人员（专职）数" prop="full_time_admin_count">
          <el-input v-model="ruleForm.full_time_admin_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="管理人员（兼职）数" prop="part_time_admin_count">
          <el-input v-model="ruleForm.part_time_admin_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="所属管理单位号" prop="ssgldwh">
          <el-input v-model="ruleForm.ssgldwh" placeholder="请输入所属管理单位号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="被列为实训基地项目支持部门" prop="support_department">
          <el-select v-model="ruleForm.support_department" filterable clearable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.supports" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="依托单位" prop="ytdw">
          <el-input v-model="ruleForm.ytdw" placeholder="请输入依托单位" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="适应专业名称" prop="major_name">
          <el-input v-model="ruleForm.major_name" placeholder="请输入适应专业名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="合作企业" prop="hzqy">
          <el-input v-model="ruleForm.hzqy" placeholder="请输入合作企业" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="批准日期" prop="approval_date">
          <el-date-picker type="date" placeholder="选择" value-format="yyyy-MM-dd" clearable
            v-model="ruleForm.approval_date" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="建立日期" prop="jlrq">
          <el-date-picker type="date" placeholder="选择建立日期" value-format="yyyy-MM-dd" clearable v-model="ruleForm.jlrq"
            style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="概述" prop="summary">
          <el-input type="textarea" v-model="ruleForm.summary" placeholder="请输入概述" style="width:532px;"
            rows='3'></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', creatTrainBase)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateTrainBase)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{ delText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteTrainBase">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog :close-on-click-modal="false"  title="组织结构" :visible.sync="organDialogVisible" width="560px">
      <div style="padding:20px;background:#fff;min-width:500px;min-height:200px;">
        <el-tree :data="treeData" node-key="id" ref="tree" :check-strictly="true" :expand-on-click-node="true" show-checkbox :default-checked-keys="checkKeys" :props="defaultProps" default-expand-all>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindOrgan">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';


export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinImport, mixinOrgan, mixinValidate],
  data() {
    return {
      classRooms: [],

      checkKeys: [],
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      levell: [1],
      formInline: {
        name: '',
      },
      ruleForm: {
        name: '',
        prop: '',
        structure_1: '',
        person: '',
        area: '',
        workstation: '',
        summary: '',
        base_no: '',
        xxdm: '',
        // base_type2: '',
        ssgldwh: '',
        jlrq: '',
        ytdw: '',
        major_name: '',
        hzqy: '',
        base_type: '',
        approval_date: '',
        training_room_count: '',
        support_department: '',
        full_time_admin_count: '',
        part_time_admin_count: '',
        training_project_total: '',
        equipment_total: '',
      },
      treeData: '',
      rules: {
        name: [{ required: true, message: '请输入实训基地名称', trigger: 'blur' }],
        prop: [{ required: true, message: '请输入性质', trigger: 'blur' }],
        structure_1: [{ required: true, message: '请选择院系', trigger: 'change' }],
        person: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
        area: [{ required: true, message: '请输入面积', trigger: 'blur' }, { validator: this.checkfloat, trigger: 'blur' }],
        workstation: [{ required: true, message: '请输入工位数', trigger: 'blur' }],
        summary: [{ required: true, message: '请输入概述', trigger: 'blur' }],
        major_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        base_no: [{ required: true, message: '请输入', trigger: 'blur' }],
        base_type: [{ required: true, message: '请选择', trigger: 'change' }],
        jlrq: [{ required: true, message: '请选择', trigger: 'change' }],
        approval_date: [{ required: true, message: '请选择', trigger: 'change' }],
        training_room_count: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        support_department: [{ required: true, message: '请选择', trigger: 'change' }],
        equipment_total: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        full_time_admin_count: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        part_time_admin_count: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],
        training_project_total: [{ required: true, message: '请输入', trigger: 'blur' }, { validator: this.checkInt, trigger: 'blur' }],

      },
      organDialogVisible: false,
      type: 'add',
      tableName: '实训日志',
      uid: '',
      action: '',
      downloadUrl: 'template/实训基地导入模版.xlsx',
      downloadName: '实训基地导入模版.xlsx',
      btnTitle: '导入实训基地数据',
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/training_base/import`;
    // this.exportUrl = `${this.baseUrlt}api/training/room/export`;
  },
  mounted() {
    // this.getList();
    this.getTree();
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    formatter(row) {
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.structure_text;
        });
      }
      return slist.join('<br/>');
      // console.log(row, column)
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },

    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    async getTree() {
      let res = await this.$api.instance.getOrgans();
      if (res.code == 0 && res.data) {
        this.treeData = res.data;
      }
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    getOrganList() {
      if (this.selectNode.level == 1) {
        this.ruleForm.structure_1 = this.selectNode.structure_names;
      } else {
        this.ruleForm.structure_1 = '';
      }

      // this.ruleForm.type_value = this.selectNode.structure_ids;
      // this.organs = [this.selectNode];
    },
    async deleteTrainBase() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteTrainBase(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getList();
      }
    },
    async creatTrainBase() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // if (params.lesson_time) {
      //   let timee = params.lesson_time.getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.creatTrainBase(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateTrainBase() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      // console.log(params)
      // return
      let res = await this.$api.update.updateTrainBase(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getTrainBase(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

@media screen and (min-width: 1000px) {

  /deep/.el-form-item__label[for=support_department],
  /deep/.el-form-item__label[for=part_time_admin_count],
  /deep/.el-form-item__label[for=full_time_admin_count] {
    line-height: 22px;
  }
}
</style>
